import { useTranslation } from 'react-i18next'
import { toast } from 'react-toastify'

import { getActions, putActions } from '../../api/actions'
import useApiCall from '../../api/useApiCall'
import { ISaveError } from '../../types/error'
import LoadingSection from '../LoadingSection/LoadingSection'
import MonacoSection from '../MonacoSection/MonacoSection'

import styles from './actions.module.scss'

function Actions() {
    const { t } = useTranslation()

    const [{ data, loading }] = useApiCall(getActions)

    const saveChanges = async (data: string) => {
        await putActions(data).catch((error) => {
            const errorData = error.response?.data as ISaveError

            toast(`${t(errorData.error)}: ${t(errorData.invalidValue)}`, {
                type: 'error',
            })

            throw new Error()
        })
    }

    return (
        <main className={styles.actions}>
            {loading ? (
                <LoadingSection />
            ) : (
                <MonacoSection
                    title="actions.yml"
                    value={data || ''}
                    handleSave={saveChanges}
                    rawData={data || ''}
                />
            )}
        </main>
    )
}

export default Actions
